import React, { useCallback, useEffect, useState } from "react";
import { Col, Container } from "reactstrap";
import { retrieveSimCards } from "utils/api";
import { defaultNgiErrorMethod, warnMessage } from "components/Common/responses/message";
import { simCardsListColumns } from "./simCardsListColumns";
import UploadModal from "./uploadModal";
import SimCardsFilter from "./simCardsFilter";
import CustomButton from "components/Common/buttons/CustomButton";
import NGITable from "components/Common/NGITable";
import useStoreFilters from "customHooks/useStoreFilters";
import { FILTER_PAGE, USER_ROLES } from "utils/constants";

const SimCards = () => {
  const [isLoading, setLoader] = useState(false);
  const [simCardList, setSimCardList] = useState(null);
  const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
  const { setFilters } = useStoreFilters(FILTER_PAGE.SIM_CARDS);

  const closeUploadModal = useCallback(() => setIsUploadModalVisible(false), []);
  const openUploadModal = useCallback(() => setIsUploadModalVisible(true), []);

  useEffect(() => {
    getSimCards();
  }, []);

  const getSimCards = useCallback((filterOptions = {}) => {
    setLoader(true);
    setFilters(filterOptions);
    retrieveSimCards(filterOptions)
      .then(res => {
        const {
          result: { items },
        } = res?.data;
        if (!items.length) {
          warnMessage(`No sim cards were found`);
          setLoader(false);
        }
        setSimCardList(res?.data || null);
        setLoader(false);
      })
      .catch(err => {
        setLoader(false);
        setSimCardList(null);
        defaultNgiErrorMethod(err);
      });
  }, []);

  return (
    <div data-testid={"sim-cards"} className="page-content">
      <Container fluid>
        <div className="filters-wrapper">
          <div className="filter-buttons">
            <CustomButton
              hideRoles={[
                USER_ROLES.INTERNAL_AUDITOR,
                USER_ROLES.GENERAL,
                USER_ROLES.IT_OPERATIONS,
                USER_ROLES.IT_OPERATIONS_LEADERSHIP,
                USER_ROLES.FINANCE,
              ]}
              icon={<i className="bx bx-upload" />}
              type="primary"
              onClick={openUploadModal}
              text="Upload Sim Cards"
            />
          </div>

          <SimCardsFilter handleFilter={getSimCards} isLoading={isLoading} openModal={openUploadModal} />
        </div>
        <Col>
          <NGITable
            filtersType={FILTER_PAGE.SIM_CARDS}
            isLoading={isLoading}
            columns={simCardsListColumns()}
            data={simCardList}
            updateList={getSimCards}
          />
        </Col>
      </Container>
      {isUploadModalVisible && (
        <UploadModal isVisible={isUploadModalVisible} onClose={closeUploadModal} onUpdate={getSimCards} />
      )}
    </div>
  );
};

export default SimCards;
